<template lang="pug">
div.card(v-if="typeof editable_creative == 'undefined' ")
  div.card-header
    h3.card-title 登録フォーム
  div.card-body
    section#creative_wrap(v-if="limit == '' || limit > creatives.length")
      div.form-group(v-if="hide_image == false")
        label(for='creative_image_url') 画像
        input#creative_image_url.form-control(type='text',
        name='image', placeholder='画像のURLを入力',
        @input='setImage',
        @blur='$v.image.$touch',
        :value="image",
        :class="{ 'is-invalid': $v.image.$invalid && $v.image.$dirty, 'is-valid': !$v.image.$invalid && $v.image.$dirty }")
        template(v-if="$v.image.$dirty")
          .invalid-feedback(v-if="!$v.image.required") 入力してください
          .invalid-feedback(v-if="!$v.image.url") URL形式が正しくありません
          .invalid-feedback(v-if="!$v.image.maxLength") 255文字以内にしてください
        p.text-muted.text-xs ※SSL化した画像URL（httpではなく、https）をご使用ください
      div.form-check.mb-3(v-if="show_show_pc == true")
        input#creatives_show_pc.form-check-input(type='checkbox', name='show_pc', @change='setShowPc', :checked="show_pc", value=1)
        label.form-check-label(for='creatives_show_pc') PCにも表示
      div.form-group(v-if="hide_image == false && show_pc == true " )
        label(for='creative_image_url') PC用画像
        input#creative_image_url.form-control(type='text',
        name='image', placeholder='画像のURLを入力',
        @input='setPcImage',
        @blur='$v.pc_image.$touch',
        :value="pc_image",
        :class="{ 'is-invalid': $v.pc_image.$invalid && $v.pc_image.$dirty, 'is-valid': !$v.pc_image.$invalid && $v.pc_image.$dirty }")
        template(v-if="$v.pc_image.$dirty")
          .invalid-feedback(v-if="!$v.pc_image.required") 入力してください
          .invalid-feedback(v-if="!$v.pc_image.url") URL形式が正しくありません
          .invalid-feedback(v-if="!$v.pc_image.maxLength") 255文字以内にしてください
        p.text-muted.text-xs ※SSL化した画像URL（httpではなく、https）をご使用ください
      div.form-group(v-if="hide_title == false")
        label(for='creative_title') タイトル
        input#creative_title.form-control(type='text',
        name='title',
        placeholder='タイトルを入力',
        @input='setTitle',
        @blur='$v.title.$touch',
        :value="title",
        :class="{ 'is-invalid': $v.title.$invalid && $v.title.$dirty, 'is-valid': !$v.title.$invalid && $v.title.$dirty }")
        template(v-if="$v.title.$dirty")
          .invalid-feedback(v-if="$v.title.required === false") 入力してください
          .invalid-feedback(v-if="$v.title.maxLength === false") 255文字以内にしてください
      div.form-check.mb-3(v-if="show_no_link == true")
        input#creatives_no_link.form-check-input(type='checkbox', name='no_link', @change='setNoLink', :checked="no_link", value=1)
        label.form-check-label(for='creatives_no_link') リンクなし
        p.text-muted.text-xs ※ポップアップにリンク設置しない場合使用してください
      div.form-check.mb-3(v-if="hide_link == false && no_link == false && show_target_blank")
        input#creatives_no_link.form-check-input(type='checkbox', name='target_blank', @change='setTargetBlank', :checked="target_blank", value=1)
        label.form-check-label(for='creatives_target_blank') 別タブで開く
        p.text-muted.text-xs ※別タブ（target="_blank"）で遷移させます
      div.form-check.mb-3(v-if="hide_link == false && no_link == false && show_target_blank")
        input#creatives_no_link.form-check-input(type='checkbox', name='inner_link', @change='setInnerLink', :checked="inner_link", value=1)
        label.form-check-label(for='creatives_target_blank') 内部リンクを使用
        p.text-muted.text-xs.mb-0 ※ポップアップをクリックした際に内部リンクで移動します。
        p.text-muted.text-xs ※クリック計測はできなくなります。

      div.form-group(v-if="hide_link == false && no_link == false")
        label(for='creative_link') リンク先URL
        input#creative_link.form-control(type='text',
        name='link',
        placeholder='リンク先のURLを入力',
        @input='setLink',
        :value="link",
        @blur='$v.link.$touch',
        :class="{ 'is-invalid': $v.link.$invalid && $v.link.$dirty, 'is-valid': !$v.link.$invalid && $v.link.$dirty }")
        template(v-if="$v.link.$dirty")
          .invalid-feedback(v-if="!$v.link.required") 入力してください
          .invalid-feedback(v-if="!$v.link.maxLength") 255文字以内にしてください
      div.form-check(v-if="hide_pr == false")
        input#creative_pr.form-check-input(type='checkbox', name='pr', @change='setPrFlag', :checked="pr_flag", value=1)
        label.form-check-label(for='creative_pr') PR を表示
      div.form-check(v-if="hide_close_btn == false")
        input#creative_close_btn_flag.form-check-input(type='checkbox', name='pr', @change='setCloseBtnFlag', :checked="close_btn_flag", value=1)
        label.form-check-label(for='creative_close_btn_flag') 削除ボタンを表示
      div.form-check.mb-3(v-if="hide_arrow_btn == false")
        input#creative_arrow_btn_flag.form-check-input(type='checkbox', name='pr', @change='setArrowBtnFlag', :checked="arrow_btn_flag", value=1)
        label.form-check-label(for='creative_arrow_btn_flag') 右矢印アイコンを表示
      div.form-group(v-if="pop_up_animations != null")
        label(for='creative_pop_up_animation') アニメーション種別
        select.form-control(@change="updatePopUpAnimation", v-model="pop_up_animation")
          option(v-for="(val,key) in pop_up_animations", :value="key") {{val}}
      div.form-group(v-if="pop_up_animations != null && show_countdown")
        countdown(:countdown_types="countdown_types")
      div.form-group(v-if="pop_up_animations != null && show_time_limit")
        time-limit(:time_limit_types="time_limit_types")
      div.form-check.mb-3(v-if="show_show_once == true")
        input#creatives_show_once.form-check-input(type='checkbox', name='pr', @change='setShowOnce', :checked="show_once", value=1)
        label.form-check-label(for='creatives_show_once') 1回のみ表示
        p.text-muted.text-xs ※1度表示したユーザに対しては表示しません
    section#creative_wrap(v-else)
      p widget設定での上限数を超えているので登録できません
  div.card-footer
    button.btn.btn-primary(type='submit', @click='submit', :class="{ 'disabled': $v.$invalid }")
      span(v-if="id!=''") 更新する
      span(v-else) 登録する
</template>

<script>
import Vue from "vue";

import { required, url, maxLength } from "vuelidate/lib/validators";

import { mapState } from "vuex";

//components
import Countdown from "./creative_form/countdown.vue";
import TimeLimit from "./creative_form/time_limit.vue";

export default {
  props: {
    widget_id: { type: String, default: "" },
    pop_up_id: { type: String, default: "" },
    area_pop_up_id: { type: String, default: "" },
    overlay_id: { type: String, default: "" },
    limit: { type: String, default: "10" },
    hide_title: { type: Boolean, default: false },
    hide_image: { type: Boolean, default: false },
    hide_link: { type: Boolean, default: false },
    hide_pr: { type: Boolean, default: false },
    hide_close_btn: { type: Boolean, default: false },
    hide_arrow_btn: { type: Boolean, default: false },
    after_submit_path: { type: String, default: "" },
    edit_creative: { type: Object, default: null },
    pop_up_animations: { type: Object, default: null },
    show_countdown: { type: Boolean, default: false },
    show_time_limit: { type: Boolean, default: false },
    show_show_once: { type: Boolean, default: false },
    show_no_link: { type: Boolean, default: false },
    show_target_blank: { type: Boolean, default: false },
    sandbox: { type: Boolean, default: false },
    countdown_types: { type: Object, default: null },
    time_limit_types: { type: Object, default: null },
    show_show_pc: { type: Boolean, default: false },
  },
  components: {
    Countdown,
    TimeLimit,
  },
  methods: {
    setTitle(e) {
      this.$store.commit("creative/setPreviewListTitle", e.target.value);
    },
    setImage(e) {
      this.$store.commit("creative/setPreviewListImage", e.target.value);
    },
    setPcImage(e) {
      this.$store.commit("creative/setPreviewListPcImage", e.target.value);
    },
    setLink(e) {
      this.$store.commit("creative/setPreviewListLink", e.target.value);
    },
    setPrFlag(e) {
      this.$store.commit("creative/setPreviewListPrFlag", e.target.checked);
    },
    setCloseBtnFlag(e) {
      this.$store.commit(
        "creative/setPreviewListCloseBtnFlag",
        e.target.checked
      );
    },
    setArrowBtnFlag(e) {
      this.$store.commit(
        "creative/setPreviewListArrowBtnFlag",
        e.target.checked
      );
    },
    updatePopUpAnimation(e) {
      this.$store.commit(
        "creative/setPreviewListPopUpAnimation",
        e.target.value
      );
    },
    setShowOnce(e) {
      this.$store.commit("creative/setPreviewListShowOnce", e.target.checked);
    },
    setShowPc(e) {
      this.$store.commit("creative/setPreviewListShowPc", e.target.checked);
    },
    setNoLink(e) {
      this.$store.commit("creative/setPreviewListNoLink", e.target.checked);
    },
    setTargetBlank(e) {
      this.$store.commit(
        "creative/setPreviewListTargetBlank",
        e.target.checked
      );
    },
    setInnerLink(e) {
      this.$store.commit("creative/setPreviewListInnerLink", e.target.checked);
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (!this.sandbox) {
          //送信処理
          this.$v.$reset();
          if (this.id != "") {
            const data = await this.$store.dispatch("creative/update");
          } else {
            const data = await this.$store.dispatch("creative/create");
          }
          if (this.after_submit_path != "") {
            location.href = this.after_submit_path;
          } else {
            if (this.id != "") {
              this.$toasted.success("クリエイティブを更新しました");
            } else {
              this.$toasted.success("クリエイティブを登録しました");
            }
            await sleep(10000);
            this.$toasted.clear();
          }
        } else {
          this.$v.$reset();
          this.$toasted.success("demo版なので登録はされません");
          await this.$store.dispatch("creative/create_demo");
        }
      }
    },
  },
  async mounted() {
    await Vue.nextTick();
    if (this.widget_id != "") {
      this.$store.commit("creative/setPreviewListWidgetId", this.widget_id);
    }
    if (this.pop_up_id != "") {
      this.$store.commit("creative/setPreviewListPopUpId", this.pop_up_id);
    }
    if (this.area_pop_up_id != "") {
      this.$store.commit(
        "creative/setPreviewListAreaPopUpId",
        this.area_pop_up_id
      );
    }
    if (this.overlay_id != "") {
      this.$store.commit("creative/setPreviewListOverlayId", this.overlay_id);
    }
    if (this.edit_creative != null) {
      if (typeof this.edit_creative.id !== "undefined") {
        this.$store.commit("creative/setPreviewListId", this.edit_creative.id);
      }
      this.$store.commit(
        "creative/setPreviewListTitle",
        this.edit_creative.title
      );
      this.$store.commit(
        "creative/setPreviewListImage",
        this.edit_creative.image
      );
      this.$store.commit(
        "creative/setPreviewListPcImage",
        this.edit_creative.pc_image
      );
      this.$store.commit(
        "creative/setPreviewListLink",
        this.edit_creative.link
      );
      this.$store.commit(
        "creative/setPreviewListCloseBtnFlag",
        this.edit_creative.close_btn_flag
      );
      this.$store.commit(
        "creative/setPreviewListArrowBtnFlag",
        this.edit_creative.arrow_btn_flag
      );
      this.$store.commit(
        "creative/setPreviewListPopUpAnimation",
        this.edit_creative.pop_up_animation
      );
      this.$store.commit(
        "creative/setPreviewListShowOnce",
        this.edit_creative.show_once
      );
      this.$store.commit(
        "creative/setPreviewListShowPc",
        this.edit_creative.show_pc
      );
      this.$store.commit(
        "creative/setPreviewListNoLink",
        this.edit_creative.no_link
      );
      this.$store.commit("creative/setCountdown", this.edit_creative.countdown);
      this.$store.commit(
        "creative/setCountBgColor",
        this.edit_creative.countdown_bg_color
      );
      this.$store.commit(
        "creative/setCountFontColor",
        this.edit_creative.countdown_font_color
      );
      this.$store.commit(
        "creative/setCountdownName",
        this.edit_creative.countdown_name
      );
      this.$store.commit(
        "creative/setCountdownType",
        this.edit_creative.countdown_type
      );
      this.$store.commit(
        "creative/setTimeLimitMin",
        this.edit_creative.time_limit_min
      );
      this.$store.commit(
        "creative/setPrefixCountdownText",
        this.edit_creative.prefix_countdown_text
      );
      this.$store.commit(
        "creative/setTimeLimit",
        this.edit_creative.time_limit
      );
      this.$store.commit(
        "creative/setTimeLimitType",
        this.edit_creative.time_limit_type
      );
      this.$store.commit(
        "creative/setTimeLimitVal",
        this.edit_creative.time_limit_val
      );
      this.$store.commit(
        "creative/setPreviewListTargetBlank",
        this.edit_creative.target_blank
      );
      this.$store.commit(
        "creative/setPreviewListInnerLink",
        this.edit_creative.inner_link
      );
    }
    if (this.hide_title) {
      this.$store.commit("creative/setPreviewListTitle", null);
    }
    this.$store.commit("creative/setCountdownUnixTimeLeft");
  },
  watch: {},
  computed: {
    id() {
      return this.$store.state.creative.preview_list.id;
    },
    title() {
      return this.$store.state.creative.preview_list.title;
    },
    image() {
      return this.$store.state.creative.preview_list.image;
    },
    pc_image() {
      return this.$store.state.creative.preview_list.pc_image;
    },
    link() {
      return this.$store.state.creative.preview_list.link;
    },
    pr_flag() {
      return this.$store.state.creative.preview_list.pr_flag;
    },
    close_btn_flag() {
      return this.$store.state.creative.preview_list.close_btn_flag;
    },
    arrow_btn_flag() {
      return this.$store.state.creative.preview_list.arrow_btn_flag;
    },
    pop_up_animation() {
      return this.$store.state.creative.preview_list.pop_up_animation;
    },
    editable_creative() {
      return this.$store.getters["creative/findEdit"];
    },
    creatives() {
      return this.$store.state.creative.lists;
    },
    show_once() {
      return this.$store.state.creative.preview_list.show_once;
    },
    show_pc() {
      return this.$store.state.creative.preview_list.show_pc;
    },
    no_link() {
      return this.$store.state.creative.preview_list.no_link;
    },
    target_blank() {
      return this.$store.state.creative.preview_list.target_blank;
    },
    inner_link() {
      return this.$store.state.creative.preview_list.inner_link;
    },
  },
  validations() {
    var obj = {};
    if (this.widget_id != "") {
      obj.title = {
        required,
        maxLength: maxLength(255),
      };
    } else {
      obj.title = {
        maxLength: maxLength(255),
      };
    }
    if (this.hide_image == false) {
      obj.image = {
        required,
        url,
        maxLength: maxLength(255),
      };
      obj.pc_image = {
        url,
        maxLength: maxLength(255),
      };
    }
    if (this.hide_link == false && this.no_link == false) {
      obj.link = {
        required,
        maxLength: maxLength(255),
      };
    }
    return obj;
  },
};
</script>
<style lang="scss" scoped></style>
